import {Component, Input, ViewEncapsulation} from '@angular/core';
import {BagggageInfo} from '../offer-card-data.model';
import {Baggage, Type} from '@shopping-angular-components/baggages';

@Component({
  selector: 'baggages-wrapper',
  template: `
    <baggages
      product="nymeria-gui"
      [flow]="flow"
      [type]="iconType"
      [locale]="locale"
      [baggageInfo]="getBaggageInfo()"
      [isAvailableModal]="true"
      [filledIcons]="true"
      [tooltipPosition]="tooltipPosition"
      [disableTooltip]="disableTooltip">
    </baggages>
  `,
    styles: [
      `
        baggages-wrapper {
          width: 50px;
        }
      `,
    ],
  encapsulation: ViewEncapsulation.None
})
export class BaggagesWrapperComponent {
  @Input() baggageInfo: BagggageInfo;
  @Input() locale: string;
  @Input() product;
  @Input() flow;
  @Input() tooltipPosition: string;
  @Input() disableTooltip: boolean = false;

  iconType = Type.ICON;

  constructor() {}

  getBaggageInfo(): Baggage {
    return {
      backpack: this.baggageInfo?.backpack,
      carryOn: this.baggageInfo?.carry_on,
      checkedBagQuantity: this.baggageInfo?.checked_bag_quantity,
      upsellingAvailable: false,
      ancillariesAvailable: false
    }
  }

}
